import API from './config';
import { GET_STATISTICS } from './urls';

const getStatistics = () => API.get(GET_STATISTICS);

export default {
  getStatistics
};
